export default __webpack_public_path__ + "static/media/part1_img.32d256df.png";